/*
 * FLX · Vista previa aproximada (motor JS) · v12.4 (09/10/2026)
 * v12.4: el editor separa la escala QUE PIDE el cliente (_flxScaleWant: A−/A+, deslizador, pellizco,
 *        reinicio, apertura) de la escala EFECTIVA (_flxScale = la pedida acotada a los límites del
 *        nombre actual). Antes, al reescribir el nombre letra a letra dentro del editor, el tope de una
 *        sola letra se quedaba guardado y el nombre no volvía a su tamaño.
 * v12.3: la mini-vista ya no guarda la escala del nombre (se quedaba en 0,5 al teclear letra a letra
 *        y el nombre salía más pequeño que en el editor).
 * v12.2: color de la pieza también desde el configurador (input[data-flx-piece]); el color del
 *        nombre ignora ese campo.
 * Extraído de snippets/flx-live-preview.liquid. El snippet conserva el markup, el CSS
 * y los textos traducidos (JSON en <script data-flx-lp-msg>); aquí solo vive el JS,
 * servido desde el CDN, cacheado entre fichas y cargado con defer (no bloquea el
 * parser ni compite con la imagen LCP).
 * Cambio funcional: NINGUNO. Mismo código que v12 inline salvo la lectura de MSG.
 * Si se edita: pasar ESLint no-undef antes de subir (ver v9.0.1).
 */
(function () {
  if (window.__flxLivePreview) return;
  window.__flxLivePreview = true;

  // v12.1: los textos traducidos llegan en <script type="application/json" data-flx-lp-msg> (Liquid)
  var MSG = (function () {
    try { return JSON.parse(document.querySelector('script[data-flx-lp-msg]').textContent); }
    catch (e) { return { missing: '', missingFont: '', missingGlyph: '', confirmed: '' }; }
  })();
  var FALLBACK_COLOR = '#e4ded5';
  var SVG_CACHE = {}; // url -> markup (cada letra se descarga UNA vez)

  // Convierte un nombre en claves de pieza: Ñ y Ç se conservan (existen
  // como letra física: NN / CC); el resto pierde diacríticos (Á->A);
  // solo A-Z; el espacio se respeta como separación.
  function nameToKeys(name) {
    var out = [];
    var chars = Array.from ? Array.from(name) : name.split('');
    for (var i = 0; i < chars.length; i++) {
      var ch = chars[i];
      if (ch === ' ') { out.push(' '); continue; }
      var up = ch.toUpperCase();
      if (up === 'Ñ') { out.push('NN'); continue; }
      if (up === 'Ç') { out.push('CC'); continue; }
      try { up = up.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) { /* noop */ }
      up = up.charAt(0);
      if (up >= 'A' && up <= 'Z') out.push(up);
    }
    return out;
  }

  // Carga el SVG de la inicial (modo svg). key para evitar recargas.
  function loadInitialSvg(wrap, url, key, cb) {
    if (SVG_CACHE[url]) { cb(SVG_CACHE[url]); return; }
    fetch(url, { mode: 'cors' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (txt) {
      // Solo contenido SVG de nuestro propio CDN
      if (txt.indexOf('<svg') === -1) throw new Error('no-svg');
      SVG_CACHE[url] = txt;
      cb(txt);
    }).catch(function () { cb(null); });
  }

  // ── Medición (v8.1): GA4 + Clarity + Shopify.analytics. Cada sumidero
  //    va en su propio try: si uno falla, los demás siguen. Nunca puede
  //    romper la preview. ──
  // Estado de sesión que Clarity muestra como tag "flx_preview"
  var CLARITY_STATE = {
    flx_preview_blocked: 'bloqueada',
    flx_preview_open: 'abierta',
    flx_preview_confirm: 'confirmada',
    flx_preview_close: null // se decide por params.confirmed
  };
  function track(wrap, event, params) {
    var payload;
    try {
      payload = Object.assign({
        product_id: wrap.getAttribute('data-product-id'),
        product_handle: wrap.getAttribute('data-product-handle')
      }, params || {});
    } catch (err) { return; }
    // 1) GA4 — gtag primero: gtag.js crea window.dataLayer y con él un
    //    push({event}) se ignora; solo GTM lee objetos {event}.
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', event, payload);
      } else if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push(Object.assign({ event: event }, payload));
      }
    } catch (err) { /* sin GA4 */ }
    // 2) Clarity — smart event + tag de estado de sesión
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', event);
        var st = CLARITY_STATE[event];
        if (event === 'flx_preview_close') {
          st = payload.confirmed === 'si' ? 'confirmada' : 'cerrada_sin_confirmar';
        }
        if (st) window.clarity('set', 'flx_preview', st);
        if (event === 'flx_preview_blocked' && payload.reason) {
          window.clarity('set', 'flx_preview_bloqueo', String(payload.reason));
        }
      }
    } catch (err) { /* sin Clarity */ }
    // 3) Shopify Web Pixels — para reenviar desde un Custom Pixel si la
    //    analítica corre en el sandbox del canal de Google
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(event, payload);
      }
    } catch (err) { /* sin Web Pixels */ }
  }
  function secondsOpen(wrap) {
    return wrap._flxOpenedAt ? Math.round((Date.now() - wrap._flxOpenedAt) / 10) / 100 : 0;
  }

  // ── Utilidades ────────────────────────────────────────────────────────
  // El swatch (variante o campo de color) ya lleva el hex como
  // background-color en línea. Se lee del DOM: sin metafields nuevos y
  // siempre sincronizado con lo que el cliente está viendo.
  function swatchColor(input) {
    if (!input) return null;
    var id = input.getAttribute('id');
    var label = null;
    if (id) {
      try { label = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]'); }
      catch (err) { label = null; }
    }
    if (!label) label = input.parentNode && input.parentNode.querySelector('label');
    if (!label) return null;
    var c = getComputedStyle(label).backgroundColor;
    if (!c || c === 'transparent' || c === 'rgba(0, 0, 0, 0)') return null;
    return c;
  }

  function p13nBlockFor(wrap) {
    var formId = wrap.getAttribute('data-form-id');
    return document.querySelector('[data-flx-p13n][data-form-id="' + formId + '"]');
  }

  // Lee todo lo que el cliente ha elegido, desde el bloque de personalización
  function readSelection(wrap) {
    var p13n = p13nBlockFor(wrap);
    var out = { initial: '', name: '', font: '', fontLabel: '', nameColor: null, initialColor: null, hasNameField: false };
    if (!p13n) return out;

    var letterEl = p13n.querySelector('input.flx-p13n__input--letter');
    var nameEl = p13n.querySelector('[data-flx-text]:not(.flx-p13n__input--letter)');
    out.hasNameField = !!nameEl; // productos solo-glifo (p. ej. números) no lo tienen
    // trim solo en los extremos: los saltos internos se conservan
    if (nameEl) out.name = (nameEl.value || '').replace(/^\s+|\s+$/g, '');
    // La inicial SIEMPRE es la primera letra del nombre, en MAYÚSCULA y
    // NORMALIZADA: sin tilde ni diéresis (Ángel→A, Úrsula→U) y la Ñ pasa
    // a N. NFD separa la letra base de sus marcas diacríticas y estas se
    // eliminan; cubre á é í ó ú ü ñ ç y equivalentes de otros idiomas.
    // El nombre del cliente NO se toca: solo la inicial de la pieza.
    function baseInitial(txt) {
      var ch = txt.trim().charAt(0);
      if (!ch) return '';
      try { ch = ch.normalize('NFD').replace(/[̀-ͯ]/g, '').charAt(0) || ch; }
      catch (err) { /* navegadores sin normalize: se usa tal cual */ }
      return ch.toUpperCase();
    }
    if (out.name) out.initial = baseInitial(out.name.replace(/[\r\n]+/g, ' '));
    // Si el producto tuviera además un campo "letra" relleno, ese valor
    // manda (misma normalización).
    if (letterEl && letterEl.value.trim()) out.initial = baseInitial(letterEl.value);

    // Tipografía elegida -> familia CSS (data-font de la opción marcada)
    var typoVal = p13n.querySelector('[data-flx-typo-value]');
    if (typoVal && typoVal.value) {
      out.fontLabel = typoVal.value;
      var opt = p13n.querySelector('[data-flx-option][aria-selected="true"]');
      if (!opt) {
        var all = p13n.querySelectorAll('[data-flx-option]');
        for (var i = 0; i < all.length; i++) {
          if (all[i].getAttribute('data-value') === typoVal.value) { opt = all[i]; break; }
        }
      }
      if (opt) out.font = opt.getAttribute('data-font') || '';
    }

    // Color del nombre: campo de color de personalización
    // (v12.2: se excluye el color de PIEZA, que también puede ser un campo del configurador)
    out.nameColor = swatchColor(p13n.querySelector('[data-flx-color]:not([data-flx-piece]):checked'));

    // Color de la inicial: swatch de variante (Option de color del tema)
    var form = document.getElementById(wrap.getAttribute('data-form-id'));
    var scope = form || document;
    out.initialColor = swatchColor(scope.querySelector('input[data-variant-input][data-color-name]:checked'))
      || swatchColor(document.querySelector('input[data-variant-input][data-color-name]:checked'))
      // v12.2: productos con el color de pieza como propiedad (sin opción de color de variante)
      || swatchColor(p13n.querySelector('input[data-flx-piece]:checked'));

    // Productos con inicial de colores FIJOS (SVG multicolor, p. ej.
    // superhéroe): el swatch de variante colorea el NOMBRE, no la inicial.
    if (wrap.getAttribute('data-name-color-variant') === 'true') {
      out.nameColor = out.initialColor;
    }

    return out;
  }

  // Escala el texto hasta ocupar EXACTAMENTE el ancho objetivo (en px):
  // crece o encoge, así el nombre siempre mide lo mismo que la inicial.
  function fitToWidthPx(el, targetPx, startPx) {
    el.style.fontSize = startPx + 'px';
    var w = el.scrollWidth;
    if (w > 0 && targetPx > 0) el.style.fontSize = Math.max(8, Math.floor(startPx * (targetPx / w))) + 'px';
  }
  // La inicial solo encoge si desborda (M, W); nunca crece
  function capToWidthPx(el, maxPx, startPx) {
    el.style.fontSize = startPx + 'px';
    var w = el.scrollWidth;
    if (w > maxPx && w > 0) el.style.fontSize = Math.floor(startPx * (maxPx / w)) + 'px';
  }

  // root = contenedor del lienzo: el diálogo (por defecto) o la
  // mini-vista en vivo junto a los campos. Mismo motor, dos destinos.
  // Contenedor de un elemento del editor. Si el diálogo ha sido
  // reubicado fuera del contenedor (Safari/WebView), se resuelve por su
  // identificador en vez de por ascendencia en el DOM.
  function wrapOf(el) {
    if (!el || !el.closest) return null;
    var w = el.closest('[data-flx-lp]');
    if (w) return w;
    var d = el.closest('[data-flx-lp-dialog]');
    var uid = d && d.getAttribute('data-flx-lp-dialog');
    if (!uid) return null;
    try { return document.querySelector('[data-flx-lp][data-uid="' + uid + '"]'); } catch (e) { return null; }
  }
  function rootOf(wrap, root) {
    if (root) return root;
    var uid = wrap.getAttribute('data-uid');
    var d = null;
    try { d = document.querySelector('[data-flx-lp-dialog="' + uid + '"]'); } catch (e) { d = null; }
    return d || wrap.querySelector('[data-flx-lp-dialog]') || wrap;
  }
  function compose(wrap, root) {
    root = rootOf(wrap, root);
    var stage = root.querySelector('[data-flx-lp-stage]');
    var iniEl = root.querySelector('[data-flx-lp-initial]');
    var nameEl = root.querySelector('[data-flx-lp-name]');
    var metaEl = root.querySelector('[data-flx-lp-meta]');
    var isMini = !!(root && root.hasAttribute && root.hasAttribute('data-flx-lp-mini'));
    if (!stage || !iniEl || !nameEl) return;

    var sel = readSelection(wrap);
    var stageW = stage.clientWidth;
    var stageH = stage.clientHeight || (stageW * 0.75);
    if (!stageW) return;

    var iniScale = parseFloat(wrap.getAttribute('data-ini-scale')) || 0.68;
    var nameScale = parseFloat(wrap.getAttribute('data-name-scale')) || 0.88;
    var nameY = parseFloat(wrap.getAttribute('data-name-y')) || 0.72;
    var pos = wrap.getAttribute('data-pos') || 'cruzado';
    var iniFamily = wrap.getAttribute('data-ini-family') || 'flx-preview-initial';

    // ── MODO NOMBRE COMPLETO (nombre_svg): el producto ES el nombre;
    //    cada letra es una pieza SVG, todas tintadas con el color de la
    //    variante. Sin capa de inicial, sin arrastre, sin tipografía. ──
    var mode = wrap.getAttribute('data-mode') || 'inicial';
    var svgPattern = wrap.getAttribute('data-svg-pattern');
    if (mode === 'nombre_svg' && svgPattern) {
      var toolsRow0 = root.querySelector('.flx-lp__tools');
      if (toolsRow0) toolsRow0.style.display = 'none';
      iniEl.textContent = '';
      if (iniEl.querySelector('svg')) iniEl.innerHTML = '';
      iniEl.style.height = '';

      var keys = nameToKeys(sel.name);
      var letterKeys = [];
      for (var ki = 0; ki < keys.length; ki++) if (keys[ki] !== ' ') letterKeys.push(keys[ki]);
      if (!letterKeys.length) { nameEl.innerHTML = ''; return; }

      // Descarga (con caché) de las letras que falten; al completar,
      // se recompone. Las repetidas solo se piden una vez.
      var urlFor = function (k) { return svgPattern.replace('{INICIAL}', encodeURIComponent(k)); };
      var missing = [];
      for (var mi = 0; mi < letterKeys.length; mi++) {
        var u = urlFor(letterKeys[mi]);
        if (!SVG_CACHE[u] && missing.indexOf(letterKeys[mi]) === -1) missing.push(letterKeys[mi]);
      }
      if (missing.length) {
        var pend = missing.length;
        missing.forEach(function (k) {
          loadInitialSvg(wrap, urlFor(k), k, function () {
            pend--;
            if (pend === 0) compose(wrap, root);
          });
        });
        return;
      }

      // Construir la fila
      nameEl.classList.add('flx-lp__name--fila');
      nameEl.style.fontSize = '';
      nameEl.style.color = sel.initialColor || FALLBACK_COLOR;
      nameEl.style.left = '50%';
      nameEl.style.top = '54%';
      var letH = Math.round(stageH * (parseFloat(wrap.getAttribute('data-letras-escala')) || 0.42));
      var html = '';
      for (var hi = 0; hi < keys.length; hi++) {
        if (keys[hi] === ' ') { html += '<span data-gap style="flex:0 0 auto"></span>'; continue; }
        var mk = SVG_CACHE[urlFor(keys[hi])];
        if (mk) html += '<span data-lt style="flex:0 0 auto;height:100%">' + mk + '</span>';
      }
      nameEl.innerHTML = html;

      function sizeRow(h) {
        nameEl.style.height = h + 'px';
        nameEl.style.gap = Math.round(h * 0.07) + 'px';
        var gaps = nameEl.querySelectorAll('[data-gap]');
        for (var g = 0; g < gaps.length; g++) gaps[g].style.width = Math.round(h * 0.3) + 'px';
      }
      sizeRow(letH);
      // Nombres largos: encoger para caber en el lienzo
      var maxW = stageW * 0.92;
      if (nameEl.scrollWidth > maxW && nameEl.scrollWidth > 0) {
        sizeRow(Math.max(24, Math.floor(letH * maxW / nameEl.scrollWidth)));
      }
      return;
    }
    if (nameEl.classList.contains('flx-lp__name--fila')) {
      nameEl.classList.remove('flx-lp__name--fila');
      nameEl.innerHTML = '';
      nameEl.style.height = '';
      nameEl.style.gap = '';
    }

    // ── Capa 1: inicial ──
    iniEl.style.color = sel.initialColor || FALLBACK_COLOR;
    iniEl.style.top = (pos === 'inferior') ? '40%' : '50%';

    if (svgPattern && sel.initial && !root._flxSvgFail) {
      // MODO SVG: la inicial es un vectorial por letra (p. ej. ondas
      // suaves), tintado vía currentColor con el color de la variante.
      var svgKey = sel.initial === 'Ñ' ? 'NN' : sel.initial;
      var svgUrl = svgPattern.replace('{INICIAL}', encodeURIComponent(svgKey));
      iniEl.style.fontSize = '0px';
      iniEl.style.height = Math.round(stageH * iniScale) + 'px';
      if (root._flxSvgKey !== svgKey) {
        root._flxSvgKey = svgKey;
        loadInitialSvg(wrap, svgUrl, svgKey, function (markup) {
          if (root._flxSvgKey !== svgKey) return; // el cliente cambió de letra
          if (markup) {
            iniEl.innerHTML = markup;
            compose(wrap, root); // recompone con la caja real del SVG
          } else {
            // Sin SVG para esa inicial (o fallo de red): cae a modo fuente
            root._flxSvgFail = true;
            compose(wrap, root);
          }
        });
        return; // esta pasada termina; la carga relanza compose
      }
      // SVG ya inyectado: si la inicial es muy ancha, se acota por ancho
      var svgEl = iniEl.querySelector('svg');
      if (svgEl && iniEl.getBoundingClientRect().width > stageW * 0.62) {
        iniEl.style.height = Math.round(stageH * iniScale * (stageW * 0.62) / iniEl.getBoundingClientRect().width) + 'px';
      }
    } else {
      // MODO FUENTE (LLP001 y por defecto)
      iniEl.style.height = '';
      if (iniEl.querySelector('svg')) iniEl.innerHTML = '';
      iniEl.textContent = sel.initial;
      iniEl.style.fontFamily = "'" + iniFamily + "', Georgia, serif";
      // Si la inicial es muy ancha (M, W), se reduce para no salirse
      capToWidthPx(iniEl, stageW * 0.62, Math.round(stageH * iniScale));
    }

    // ── Capa 2: nombre (solo si el producto lo tiene) ──
    var toolsRow = root.querySelector('.flx-lp__tools');
    if (toolsRow) toolsRow.style.display = sel.hasNameField ? '' : 'none';
    // ── DOS LÍNEAS ──
    // Las define el CLIENTE con Enter en el campo (campos multilínea).
    // Nunca se parte el nombre por nuestra cuenta: lo que escribe es
    // exactamente lo que se fabrica.
    var lineas = sel.name.split(/\r?\n/).map(function (l) { return l.trim(); })
                         .filter(function (l) { return l.length; });
    if (lineas.length > 1) {
      nameEl.style.whiteSpace = 'pre';
      nameEl.style.textAlign = 'center';
      nameEl.textContent = lineas.slice(0, 2).join('\n');
    } else {
      nameEl.style.whiteSpace = '';
      nameEl.style.textAlign = '';
      nameEl.textContent = sel.name;
    }
    if (!sel.name) { nameEl.style.fontSize = ''; return; }
    var forcedFam = wrap.getAttribute('data-name-family');
    nameEl.style.fontFamily = forcedFam ? ("'" + forcedFam + "', cursive")
      : (sel.font ? ("'" + sel.font + "', cursive") : 'cursive');
    nameEl.style.color = sel.nameColor || '#ffffff';

    // El nombre se dimensiona y coloca RESPECTO A LA INICIAL, no al lienzo:
    // ancho = nameScale × ancho real de la G; vertical = nameY dentro de
    // la caja de la G (0 = borde superior, 1 = base).
    var stRect = stage.getBoundingClientRect();
    var iniRect = iniEl.getBoundingClientRect();
    var iniW = iniRect.width || (stageW * 0.5);
    fitToWidthPx(nameEl, iniW * nameScale, Math.round(stageH * 0.30));
    // Suelo de tamaño: con nombres largos sobre iniciales estrechas (J, I)
    // el ajuste al ancho dejaría el nombre ilegible. Nunca por debajo del
    // 11% del lienzo; el taller lo trabajará en proporción.
    var fitted = parseFloat(nameEl.style.fontSize) || 1;
    var minPx = stageH * 0.11;
    var basePx = Math.max(fitted, minPx);

    // ── LÍMITES DE ESCALA DINÁMICOS ──
    // El rango del deslizador/pellizco no es fijo: se calcula para ESTE
    // nombre sobre ESTA inicial, de modo que el nombre nunca desborde el
    // lienzo ni supere una fracción razonable de la altura de la letra.
    // Un nombre corto ("Ol") tendrá un máximo pequeño; uno largo, mayor
    // margen para ampliar. Las normas de colocación no cambian.
    nameEl.style.fontSize = Math.round(basePx) + 'px';
    var baseW = nameEl.scrollWidth || 1;
    var baseH = nameEl.getBoundingClientRect().height || basePx;
    var iniH  = iniRect.height || stageH * 0.6;
    var maxByW = (stageW * 0.90) / baseW;          // no salir del lienzo
    var maxByH = (iniH * 0.70) / baseH;            // no tapar la inicial
    var maxS = Math.max(0.5, Math.min(2.0, maxByW, maxByH));
    var minS = Math.max(0.5, Math.min(maxS, (iniW * 0.45) / baseW));  // legible
    var sMin = Math.round(minS * 20) / 20;
    var sMax = Math.round(maxS * 20) / 20;
    if (sMin > sMax) sMin = sMax;
    var sc;
    if (isMini) {
      // v12.3: la mini NO escribe la escala compartida (wrap._flxScale/Min/Max). Antes, al teclear
      // letra a letra ("A" → "An" → "Anna"), el tope de una sola letra (0,5) se guardaba y ya no
      // volvía a 1: la mini salía con el nombre pequeño y el editor (que reinicia a 1 al abrir) grande.
      // Ahora la mini usa la escala del último diseño confirmado (o 1), acotada a SUS límites.
      sc = Math.max(sMin, Math.min(sMax, wrap._flxSaved ? wrap._flxSaved.s : 1));
    } else {
      wrap._flxScaleMin = sMin;
      wrap._flxScaleMax = sMax;
      // v12.4: se acota la escala PEDIDA, no la última efectiva (no se arrastra el tope de un nombre corto)
      var want = (wrap._flxScaleWant != null) ? wrap._flxScaleWant : (wrap._flxScale || 1);
      wrap._flxScale = Math.max(sMin, Math.min(sMax, want));
      if (typeof syncRange === 'function') syncRange(wrap);
      sc = wrap._flxScale;
    }

    var finalPx = basePx * sc;
    nameEl.style.fontSize = Math.round(finalPx) + 'px';
    // Red de seguridad final: jamás fuera del lienzo
    if (nameEl.scrollWidth > stageW * 0.94) {
      nameEl.style.fontSize = Math.max(8, Math.floor(finalPx * (stageW * 0.94) / nameEl.scrollWidth)) + 'px';
    }

    var userPos = wrap._flxNamePos; // posición arrastrada por el cliente
    if (userPos) {
      nameEl.style.left = userPos.x + '%';
      nameEl.style.top = userPos.y + '%';
      wrap._flxReclamp = true; // se reacota al final con el tamaño actual
    } else if (pos === 'inferior') {
      nameEl.style.left = '50%';
      nameEl.style.top = '82%';
    } else {
      nameEl.style.left = '50%';
      var iniTopPct = ((iniRect.top - stRect.top) / (stRect.height || 1)) * 100;
      var iniHPct = (iniRect.height / (stRect.height || 1)) * 100;
      nameEl.style.top = (iniTopPct + iniHPct * nameY) + '%';
    }

    // ── SUELO COMPARTIDO ──
    // La base de la inicial es también la base del nombre: se reacota
    // SIEMPRE con las medidas ya renderizadas (tamaño, escala y número
    // de líneas actuales), no solo al arrastrar.
    var nmNow = nameEl.getBoundingClientRect();
    if (nmNow.height) {
      var cNow = clampNameCenter(wrap, nmNow.left + nmNow.width / 2, nmNow.top + nmNow.height / 2, root);
      nameEl.style.left = cNow.x + '%';
      nameEl.style.top = cNow.y + '%';
      // Solo el EDITOR escribe la posición compartida; la mini nunca la pisa
      if (wrap._flxNamePos && !isMini) wrap._flxNamePos = cNow;
    }

    if (metaEl) {
      var bits = [];
      if (sel.fontLabel) bits.push(sel.fontLabel);
      metaEl.textContent = bits.join(' · ');
    }

    // Cuando terminen de cargar las fuentes cambian las métricas: se
    // recompone entero una vez (tamaños Y posición dependen de la G real)
    if (document.fonts && document.fonts.ready && !root._flxRefitting) {
      root._flxRefitting = true;
      document.fonts.ready.then(function () {
        requestAnimationFrame(function () {
          compose(wrap, root);
          root._flxRefitting = false;
        });
      });
    }
  }

  // ── Apertura / cierre ─────────────────────────────────────────────────
  var lastTrigger = null;

  function showNotice(wrap, msg) {
    var n = wrap.querySelector('[data-flx-lp-notice]');
    if (!n) return;
    n.classList.remove('flx-lp__notice--ok');
    if (msg) { n.textContent = msg; n.hidden = false; }
    else { n.hidden = true; }
  }

  function focusFirstEmpty(wrap) {
    var p13n = p13nBlockFor(wrap);
    if (!p13n) return;
    var target = p13n.querySelector('[data-flx-text]:not(.flx-p13n__input--letter)');
    if (!target || target.value.trim()) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    requestAnimationFrame(function () { target.focus({ preventScroll: true }); });
  }

  function openDialog(wrap, trigger) {
    var sel = readSelection(wrap);
    var p13n = p13nBlockFor(wrap);
    // Productos SOLO-GLIFO (p. ej. números de cumpleaños, sin campo de
    // nombre): basta el glifo; la tipografía no aplica porque no hay
    // texto caligráfico que dibujar.
    if (!sel.hasNameField) {
      if (!sel.initial) {
        showNotice(wrap, MSG.missingGlyph);
        var letEl = p13n && p13n.querySelector('input.flx-p13n__input--letter');
        if (letEl) {
          letEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          requestAnimationFrame(function () { letEl.focus({ preventScroll: true }); });
        }
        track(wrap, 'flx_preview_blocked', { reason: 'glifo' });
        return;
      }
    } else {
      if (!sel.name) {
        showNotice(wrap, MSG.missing);
        focusFirstEmpty(wrap);
        track(wrap, 'flx_preview_blocked', { reason: 'nombre' });
        return;
      }
      // Tipografía obligatoria: sin fuente elegida la preview mentiría
      // (salvo productos con fuente forzada por configuración)
      var typoVal = p13n && p13n.querySelector('[data-flx-typo-value]');
      if (!wrap.getAttribute('data-name-family') && typoVal && !typoVal.value) {
        showNotice(wrap, MSG.missingFont);
        var trg = p13n.querySelector('.flx-p13n__trigger');
        if (trg) {
          trg.scrollIntoView({ behavior: 'smooth', block: 'center' });
          requestAnimationFrame(function () { trg.focus({ preventScroll: true }); });
        }
        track(wrap, 'flx_preview_blocked', { reason: 'tipografia' });
        return;
      }
    }
    showNotice(wrap, null);
    adoptFields(wrap);
    wrap._flxDragTracked = false;
    wrap._flxScaleTracked = false;
    // Estado inicial de la apertura = último diseño confirmado (si hay).
    // Lo no confirmado en aperturas anteriores se descarta aquí.
    wrap._flxNamePos = wrap._flxSaved ? { x: wrap._flxSaved.x, y: wrap._flxSaved.y } : null;
    wrap._flxScale = wrap._flxSaved ? wrap._flxSaved.s : 1;
    wrap._flxScaleWant = wrap._flxScale;
    syncRange(wrap);
    wrap._flxOpens = (wrap._flxOpens || 0) + 1;
    wrap._flxOpenedAt = Date.now();
    wrap._flxConfirmedThisOpen = false;
    track(wrap, 'flx_preview_open', { open_n: wrap._flxOpens });
    setPreviewState(wrap, 'abierta sin confirmar');
    lastTrigger = trigger || null;
    wrap.querySelector('[data-flx-lp-backdrop]').hidden = false;
    var dlg = rootOf(wrap);
    dlg.hidden = false;
    document.body.classList.add('flx-lp-open');
    // Se compone tras el layout, con el lienzo ya medible
    requestAnimationFrame(function () { compose(wrap); });
    var close = wrap.querySelector('[data-flx-lp-close]');
    if (close) close.focus({ preventScroll: true });
  }

  // Traslado de los campos reales al editor (y vuelta a su sitio).
  // Se deja un marcador en el DOM original para restituir la posición
  // exacta aunque el tema reordene bloques.
  function adoptOne(node, slot) {
    if (!node || node.closest('[data-flx-lp-fields]')) return;
    if (!node._flxHome) {
      var mark = document.createComment('flx-home');
      node.parentNode.insertBefore(mark, node);
      node._flxHome = mark;
    }
    slot.appendChild(node);
  }
  function adoptFields(wrap) {
    var slot = rootOf(wrap).querySelector('[data-flx-lp-fields]');
    if (!slot) return;
    // 1º los selectores de color de VARIANTE (p. ej. "Color - Letra"),
    // 2º el bloque de personalización.
    // OJO: en Impulse 2.0 el selector de variante es un BLOQUE aparte y
    // vive FUERA del <form> (se asocia por atributo form=). Hay que
    // buscarlo en la SECCIÓN de producto, no en el formulario.
    var sec = document.getElementById('ProductSection-' + wrap.getAttribute('data-uid'))
           || wrap.closest('[id^="ProductSection-"]')
           || document;
    sec.querySelectorAll('.variant-input-wrap').forEach(function (fs) {
      if (!fs.querySelector('input[data-variant-input][data-color-name]')) return;
      // El rótulo de la opción ("COLOR - LETRA — Blanco Marfil") es un
      // <label class="variant__label"> HERMANO ANTERIOR del fieldset,
      // no va dentro: se traslada con él para no perder el título.
      var lbl = fs.previousElementSibling;
      if (lbl && lbl.classList && lbl.classList.contains('variant__label')) adoptOne(lbl, slot);
      adoptOne(fs, slot);
    });
    adoptOne(p13nBlockFor(wrap), slot);
  }
  function releaseFields(wrap) {
    var slot = rootOf(wrap).querySelector('[data-flx-lp-fields]');
    if (!slot) return;
    [].slice.call(slot.children).forEach(function (node) {
      if (node._flxHome && node._flxHome.parentNode) {
        node._flxHome.parentNode.insertBefore(node, node._flxHome);
      }
    });
  }

  function closeAll() {
    document.querySelectorAll('[data-flx-lp]').forEach(function (wrap) {
      var dlg = rootOf(wrap);
      if (dlg === wrap) dlg = null;
      var bd = wrap.querySelector('[data-flx-lp-backdrop]');
      var wasOpen = dlg && !dlg.hidden;
      releaseFields(wrap);
      if (dlg) dlg.hidden = true;
      if (bd) bd.hidden = true;
      if (wasOpen) {
        // Métrica de fuga de la preview: abierta y cerrada sin confirmar
        track(wrap, 'flx_preview_close', {
          confirmed: wrap._flxConfirmedThisOpen ? 'si' : 'no',
          seconds_open: secondsOpen(wrap),
          name_moved: wrap._flxDragTracked ? 'si' : 'no',
          name_scaled: wrap._flxScaleTracked ? 'si' : 'no'
        });
        wrap._flxOpenedAt = null;
      }
    });
    document.body.classList.remove('flx-lp-open');
    if (lastTrigger) { lastTrigger.focus({ preventScroll: true }); lastTrigger = null; }
  }

  function anyOpen() {
    return document.querySelector('[data-flx-lp-dialog]:not([hidden])');
  }

  // ── Interacción con el nombre: arrastre (1 dedo/puntero) y tamaño
  //    (pellizco con 2 dedos, o botones A−/A+). El área de trabajo es la
  //    CAJA DE LA INICIAL: se acota el nombre ENTERO (con márgenes de
  //    medio ancho/alto), no solo su centro, para que nunca asome fuera.
  //    NADA se guarda en el pedido hasta pulsar Confirmar: cerrar con la
  //    X descarta los cambios de esta apertura.
  // Estado de uso de la previsualización, visible para el taller:
  //   no utilizada | abierta sin confirmar | confirmada
  function setPreviewState(wrap, value) {
    var form = document.getElementById(wrap.getAttribute('data-form-id'));
    if (!form) return;
    var el = form.querySelector('input[name="properties[_flx_preview_estado]"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[_flx_preview_estado]';
      form.appendChild(el);
    }
    el.value = value;
  }
  // Valor inicial "no utilizada". OJO: este bloque se renderiza ANTES que
  // el formulario de compra (buy_buttons va después en la plantilla), así
  // que al ejecutarse el script el <form> aún no existe. Se inicializa al
  // terminar el parseo y se reintenta unas veces por si el tema lo monta
  // por JS más tarde.
  function initPreviewState(attempt) {
    var pending = false;
    document.querySelectorAll('[data-flx-lp]').forEach(function (w) {
      var form = document.getElementById(w.getAttribute('data-form-id'));
      if (!form) { pending = true; return; }
      if (!form.querySelector('input[name="properties[_flx_preview_estado]"]')) setPreviewState(w, 'no utilizada');
    });
    if (pending && attempt < 10) setTimeout(function () { initPreviewState(attempt + 1); }, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initPreviewState(0); });
  else initPreviewState(0);

  function ensureHiddenProp(wrap, value) {
    var form = document.getElementById(wrap.getAttribute('data-form-id'));
    if (!form) return;
    var el = form.querySelector('input[name="properties[_flx_pos_nombre]"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[_flx_pos_nombre]';
      form.appendChild(el);
    }
    el.value = value;
  }

  // Hueco entre el borde inferior de la caja de un texto y el pie real
  // de sus glifos (última línea). 0 si el elemento es un SVG.
  var __mc = null;
  // Hueco entre el borde inferior de la caja de un texto y el pie REAL de
  // sus glifos (última línea). 0 si el elemento es un SVG.
  //
  // v10.6: la línea base se mide EN EL DOM con un marcador inline-block
  // (su borde inferior cae exactamente en la baseline de la última línea),
  // en vez de deducirla de fontBoundingBoxAscent/Descent, que Safari iOS
  // reporta distinto a Chrome y dejaba el nombre unos px por debajo del pie
  // de la inicial. El descenso bajo la baseline sí se mide con canvas
  // (actualBoundingBoxDescent, soportado en todos los navegadores), con
  // un fallback CONSERVADOR: el nombre asume descenso grande (sube), la
  // inicial asume descenso nulo (suelo más alto). Errar siempre hacia
  // arriba: el nombre nunca queda por debajo.
  function glyphBottomGap(el, text, isName) {
    if (!el || el.querySelector('svg') || !text) return 0;
    try {
      var cs = getComputedStyle(el);
      var F = parseFloat(cs.fontSize) || 16;
      var mk = document.createElement('span');
      mk.setAttribute('aria-hidden', 'true');
      mk.style.cssText = 'display:inline-block;width:0;height:0;padding:0;margin:0;border:0;vertical-align:baseline;';
      el.appendChild(mk);
      var baseline = mk.getBoundingClientRect().bottom;
      var boxBottom = el.getBoundingClientRect().bottom;
      el.removeChild(mk);
      __mc = __mc || document.createElement('canvas').getContext('2d');
      __mc.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + F + 'px ' + cs.fontFamily;
      var lines = text.split(/\r?\n/);
      var m = __mc.measureText(lines[lines.length - 1]);
      var ad = (m && typeof m.actualBoundingBoxDescent === 'number') ? m.actualBoundingBoxDescent
             : (isName ? F * 0.25 : 0);
      var gap = boxBottom - (baseline + ad);
      // Puede ser NEGATIVO: la cola de una letra (y, g, p…) sobresale a menudo
      // de la caja en caligráficas. Recortarlo a 0 dejaba el nombre bajo el pie.
      return gap;
    } catch (err) { return 0; }
  }

  // REGLAS DE LÍMITES del nombre respecto a la inicial:
  //  - horizontal: dentro de la inicial; si es más ancho, se desliza con
  //    topes en los bordes (izq. con izq., dcha. con dcha.), nunca fuera
  //    del lienzo.
  //  - vertical: NUNCA por debajo del pie real de los glifos de la inicial
  //    (suelo compartido); si es más alto que ella, se apoya en ese suelo.
  function clampNameCenter(wrap, cx, cy, root) {
    root = rootOf(wrap, root);
    var stage = root.querySelector('[data-flx-lp-stage]');
    var iniEl = root.querySelector('[data-flx-lp-initial]');
    var nameEl = root.querySelector('[data-flx-lp-name]');
    var st = stage.getBoundingClientRect();
    var ini = iniEl.getBoundingClientRect();
    var nm = nameEl.getBoundingClientRect();
    var hw = nm.width / 2, hh = nm.height / 2;
    var minX = ini.left + hw, maxX = ini.right - hw;
    var iniFloor = ini.bottom - glyphBottomGap(iniEl, iniEl.textContent, false);
    var nmGap = glyphBottomGap(nameEl, nameEl.textContent, true);
    var SAFE = 2; // margen de seguridad en px: mejor 2px arriba que 1px abajo
    var minY = ini.top + hh, maxY = iniFloor + nmGap - hh - SAFE;
    if (minX > maxX) {
      minX = ini.right - hw;
      maxX = ini.left + hw;
      minX = Math.max(minX, st.left + hw);
      maxX = Math.min(maxX, st.right - hw);
    }
    if (minY > maxY) { minY = maxY = iniFloor + nmGap - hh - SAFE; }
    cx = Math.max(minX, Math.min(maxX, cx));
    cy = Math.max(minY, Math.min(maxY, cy));
    return {
      x: Math.round(((cx - st.left) / st.width) * 1000) / 10,
      y: Math.round(((cy - st.top) / st.height) * 1000) / 10
    };
  }

  var flxDrags = {}; // pointerId -> { wrap, nameEl, x, y }

  function wrapPointers(wrap) {
    var ids = [];
    for (var id in flxDrags) if (flxDrags[id].wrap === wrap) ids.push(id);
    return ids;
  }
  function nameCenterOf(wrap) {
    var n = rootOf(wrap).querySelector('[data-flx-lp-name]');
    var r = n.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }
  function syncRange(wrap) {
    var rg = rootOf(wrap).querySelector('[data-flx-lp-range]');
    if (!rg) return;
    var mn = Math.round((wrap._flxScaleMin || 0.5) * 100);
    var mx = Math.round((wrap._flxScaleMax || 2) * 100);
    if (mx <= mn) mx = mn + 5;
    rg.min = mn; rg.max = mx;
    rg.value = Math.round((wrap._flxScale || 1) * 100);
    // Si no hay margen real, el control se atenúa (no se oculta: informa)
    rg.disabled = (mx - mn) < 10;
  }
  function clampScale(wrap, v) {
    return Math.max(wrap._flxScaleMin || 0.5, Math.min(wrap._flxScaleMax || 2, v));
  }

  // Cualquier punto del lienzo del editor sirve: 1 dedo mueve, 2 escalan.
  document.addEventListener('pointerdown', function (e) {
    var stage = e.target.closest('[data-flx-lp-stage]');
    if (!stage || stage.closest('[data-flx-lp-mini]')) return;
    var wrap = wrapOf(stage);
    if (!wrap) return;
    var dm = wrap.getAttribute('data-mode') || 'inicial';
    if (dm === 'nombre_svg' || dm === 'marco_svg') return;   // sin colocación libre
    var nameEl = rootOf(wrap).querySelector('[data-flx-lp-name]');
    if (!nameEl || !nameEl.textContent) return;
    e.preventDefault();
    try { stage.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
    flxDrags[e.pointerId] = { wrap: wrap, nameEl: nameEl, stage: stage, x: e.clientX, y: e.clientY };
    nameEl.classList.add('is-dragging');
    var ids = wrapPointers(wrap);
    if (ids.length === 2) {
      var a = flxDrags[ids[0]], b = flxDrags[ids[1]];
      wrap._flxPinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: wrap._flxScale || 1 };
    } else {
      // Arrastre RELATIVO: se guarda el centro actual del nombre y el
      // punto de partida del dedo; el nombre se mueve por diferencia, así
      // que nunca salta aunque toques lejos del texto.
      wrap._flxDragFrom = { p: { x: e.clientX, y: e.clientY }, c: nameCenterOf(wrap) };
    }
  });

  document.addEventListener('pointermove', function (e) {
    var d = flxDrags[e.pointerId];
    if (!d) return;
    d.x = e.clientX; d.y = e.clientY;
    var wrap = d.wrap;
    var ids = wrapPointers(wrap);
    if (ids.length >= 2 && wrap._flxPinch) {
      var a = flxDrags[ids[0]], b = flxDrags[ids[1]];
      var dist = Math.hypot(a.x - b.x, a.y - b.y) || 1;
      wrap._flxScale = clampScale(wrap, wrap._flxPinch.s * (dist / wrap._flxPinch.d));
      wrap._flxScaleWant = wrap._flxScale;
      syncRange(wrap);
      compose(wrap);
      if (!wrap._flxScaleTracked) { wrap._flxScaleTracked = true; track(wrap, 'flx_preview_resize', { via: 'pinch' }); }
      return;
    }
    var from = wrap._flxDragFrom;
    if (!from) return;
    var pos = clampNameCenter(wrap,
      from.c.x + (e.clientX - from.p.x),
      from.c.y + (e.clientY - from.p.y));
    d.nameEl.style.left = pos.x + '%';
    d.nameEl.style.top = pos.y + '%';
    wrap._flxNamePos = pos;
    if (!wrap._flxDragTracked) { wrap._flxDragTracked = true; track(wrap, 'flx_preview_drag', {}); }
  });

  function endPointer(e) {
    var d = flxDrags[e.pointerId];
    if (!d) return;
    delete flxDrags[e.pointerId];
    var left = wrapPointers(d.wrap);
    if (!left.length) {
      d.nameEl.classList.remove('is-dragging');
      d.wrap._flxPinch = null;
      d.wrap._flxDragFrom = null;
    } else if (left.length === 1) {
      // Al levantar un dedo del pellizco, el que queda sigue moviendo
      d.wrap._flxPinch = null;
      d.wrap._flxDragFrom = { p: { x: flxDrags[left[0]].x, y: flxDrags[left[0]].y }, c: nameCenterOf(d.wrap) };
    }
  }
  document.addEventListener('pointerup', endPointer);
  document.addEventListener('pointercancel', endPointer);

  // ── Confirmar diseño: renderiza la composición a un canvas y adjunta
  //    el PNG como line item property de tipo archivo (_flx_vista_previa).
  //    El formulario de Impulse ya envía multipart (subida nativa del
  //    sistema de personalización), así que el archivo viaja con /cart/add
  //    sin backend: en el pedido del admin aparece como enlace a la imagen.
  function currentNamePos(wrap) {
    // Lienzo del EDITOR (no la mini, que va antes en el DOM)
    var root = rootOf(wrap);
    var stage = root.querySelector('[data-flx-lp-stage]');
    var nameEl = root.querySelector('[data-flx-lp-name]');
    var st = stage.getBoundingClientRect();
    var nm = nameEl.getBoundingClientRect();
    if (!st.width || !st.height) return null;
    return {
      x: Math.round(((nm.left + nm.width / 2 - st.left) / st.width) * 1000) / 10,
      y: Math.round(((nm.top + nm.height / 2 - st.top) / st.height) * 1000) / 10
    };
  }
  function drawLayer(ctx, el, st, scale, done) {
    var r = el.getBoundingClientRect();
    var cs = getComputedStyle(el);
    ctx.shadowColor = 'rgba(0,0,0,0.18)';
    ctx.shadowBlur = 8 * scale;
    ctx.shadowOffsetY = 6 * scale;
    var svgs = el.querySelectorAll('svg');
    if (svgs.length > 1) {
      // Fila de letras (modo nombre_svg): se dibujan en cadena
      var color = getComputedStyle(el).color;
      var idx = 0;
      (function nextSvg() {
        if (idx >= svgs.length) { done(); return; }
        var sv = svgs[idx++];
        var rr = sv.getBoundingClientRect();
        var cl = sv.cloneNode(true);
        cl.setAttribute('width', Math.round(rr.width * scale));
        cl.setAttribute('height', Math.round(rr.height * scale));
        var xm = new XMLSerializer().serializeToString(cl).split('currentColor').join(color);
        // iOS/WebKit no renderiza SVG servido por blob: en <img>. Data URI si.
        var u2 = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xm);
        var im2 = new Image();
        im2.onload = function () {
          ctx.drawImage(im2, (rr.left - st.left) * scale, (rr.top - st.top) * scale);
          nextSvg();
        };
        im2.onerror = function () {
          if (window.__flxReport) window.__flxReport('snapshot svg failed', 'letter-row');
          nextSvg();
        };
        im2.src = u2;
      })();
      return;
    }
    var svg = svgs[0];
    if (svg) {
      // Capa SVG (modo ondas): se serializa con el tinte aplicado y se
      // pinta como imagen. Blob same-origin => el canvas NO queda tainted.
      var clone = svg.cloneNode(true);
      clone.setAttribute('width', Math.round(r.width * scale));
      clone.setAttribute('height', Math.round(r.height * scale));
      var xml = new XMLSerializer().serializeToString(clone).split('currentColor').join(cs.color);
      // iOS/WebKit no renderiza SVG servido por blob: en <img>. Data URI si.
      var url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
      var img = new Image();
      img.onload = function () {
        ctx.drawImage(img, (r.left - st.left) * scale, (r.top - st.top) * scale);
        done();
      };
      img.onerror = function () {
        if (window.__flxReport) window.__flxReport('snapshot svg failed', 'single-layer');
        done();
      };
      img.src = url;
      return;
    }
    // v11 · El tamaño se CALIBRA con lo que se ve en pantalla, no con el
    // font-size declarado: en algunos móviles (navegador de Instagram /
    // Facebook con texto del sistema ampliado, autoajuste de iOS)
    // getComputedStyle no coincide con el texto pintado y la foto salía
    // con el nombre hasta ~2,5x más grande. Además dibuja 2 líneas.
    var family = cs.fontStyle + ' ' + cs.fontWeight + ' ';
    var fs = parseFloat(cs.fontSize) || 16;
    var lines = String(el.textContent).split(/\r?\n/);
    ctx.font = family + (fs * scale) + 'px ' + cs.fontFamily;
    var widest = 0;
    for (var li = 0; li < lines.length; li++) widest = Math.max(widest, ctx.measureText(lines[li]).width);
    var k = (widest > 0 && r.width > 0) ? (r.width * scale) / widest : 1;
    if (!isFinite(k) || k <= 0) k = 1;
    var px = fs * scale * k;
    ctx.font = family + px + 'px ' + cs.fontFamily;
    if (el.hasAttribute('data-flx-lp-name')) el._flxFontFix = k;
    ctx.fillStyle = cs.color;
    ctx.textAlign = 'center';
    // v11.1 · VERTICAL: se usa la LÍNEA BASE REAL medida en pantalla (un
    // marcador inline de altura 0 cae exactamente en ella) y se dibuja con
    // textBaseline 'alphabetic'. Antes se centraba con 'middle', que cada
    // fuente interpreta distinto: en DynaPuff o Noto Serif la foto
    // desplazaba letra y nombre y el nombre podía salir bajo el pie.
    ctx.textBaseline = 'alphabetic';
    var cx = (r.left + r.width / 2 - st.left) * scale;
    var mk = document.createElement('span');
    mk.setAttribute('aria-hidden', 'true');
    mk.style.cssText = 'display:inline-block;width:0;height:0;padding:0;margin:0;border:0;vertical-align:baseline;';
    el.appendChild(mk);
    var lastBase = mk.getBoundingClientRect().bottom;   // base de la ÚLTIMA línea
    el.removeChild(mk);
    var step = r.height / lines.length;                  // salto entre líneas
    for (var lj = 0; lj < lines.length; lj++) {
      var base = lastBase - (lines.length - 1 - lj) * step;
      ctx.fillText(lines[lj], cx, (base - st.top) * scale);
    }
    done();
  }
  function snapshot(wrap, cb) {
    // La FOTO del pedido sale del lienzo del EDITOR, no de la mini
    var root = rootOf(wrap);
    // Jamás fotografiar la mini: el lienzo de la foto es SIEMPRE el del editor
    var stage = root.querySelector('[data-flx-lp-stage]:not(.flx-lp__stage--mini)')
             || root.querySelector('[data-flx-lp-stage]');
    if (stage && stage.classList.contains('flx-lp__stage--mini')) { wrap._flxCanvasSize = 'mini-rechazada'; cb(null); return; }
    var st = stage.getBoundingClientRect();
    if (!st.width || !document.createElement('canvas').toBlob) { cb(null); return; }
    var scale = 2; // 2x para nitidez en el admin
    var c = document.createElement('canvas');
    c.width = Math.round(st.width * scale);
    c.height = Math.round(st.height * scale);
    wrap._flxCanvasSize = c.width + 'x' + c.height; // trazabilidad en el pedido
    var ctx = c.getContext('2d');
    var g = ctx.createLinearGradient(0, 0, 0, c.height);
    g.addColorStop(0, '#f6f4f1');
    g.addColorStop(1, '#eceae6');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, c.width, c.height);
    // v12 · AUTOVERIFICACIÓN DE LA FOTO. Letra y nombre se dibujan en
    // lienzos separados, se miden sus PÍXELES reales y se comprueban las
    // normas antes de componer:
    //   1. El pie del nombre nunca por debajo del pie de la letra.
    //   2. El nombre nunca fuera del lienzo por arriba/abajo.
    // Si la foto las incumple (fallo de un navegador, una fuente rara…),
    // el nombre se recoloca en la foto y queda anotado en el pedido
    // (foto:ajustada) + aviso al monitor de errores. Solo aplica al modo
    // estándar (letra + nombre); los otros modos no tienen suelo.
    wrap._flxPhotoFix = '';
    var iniEl = root.querySelector('[data-flx-lp-initial]');
    var nmEl = root.querySelector('[data-flx-lp-name]');
    var mode = wrap.getAttribute('data-mode') || 'inicial';
    var checkable = (mode === 'inicial') && nmEl && nmEl.textContent && iniEl && iniEl.textContent !== undefined;
    function layer() { var x = document.createElement('canvas'); x.width = c.width; x.height = c.height; return x; }
    function inkBox(cv) {
      // Filas/columnas con tinta opaca (alfa > 128: ignora sombras suaves)
      var d = cv.getContext('2d').getImageData(0, 0, cv.width, cv.height).data;
      var W = cv.width, H = cv.height, top = -1, bot = -1, lef = W, rig = -1;
      for (var y = 0; y < H; y++) {
        var row = false;
        for (var x2 = 0; x2 < W; x2++) {
          if (d[(y * W + x2) * 4 + 3] > 128) { row = true; if (x2 < lef) lef = x2; if (x2 > rig) rig = x2; }
        }
        if (row) { if (top < 0) top = y; bot = y; }
      }
      return top < 0 ? null : { top: top, bottom: bot, left: lef, right: rig };
    }
    var cI = layer(), cN = layer();
    drawLayer(cI.getContext('2d'), iniEl, st, scale, function () {
      drawLayer(cN.getContext('2d'), nmEl, st, scale, function () {
        var dy = 0;
        if (checkable) {
          try {
            var bI = inkBox(cI), bN = inkBox(cN);
            if (bI && bN) {
              var tol = Math.round(1 * scale);
              if (bN.bottom > bI.bottom + tol) dy = bI.bottom - bN.bottom;            // regla 1
              if (bN.top + dy < 0) dy = -bN.top;                                      // regla 2 (arriba)
              if (bN.bottom + dy > c.height - 1) dy = (c.height - 1) - bN.bottom;     // regla 2 (abajo)
            }
          } catch (e) {
            // Lienzo no legible (seguridad del navegador): no se verifica
            wrap._flxPhotoFix = 'sin-verificar';
          }
        }
        if (dy !== 0) {
          wrap._flxPhotoFix = 'ajustada(' + Math.round(dy / scale) + 'px)';
          if (window.__flxReport) window.__flxReport('snapshot corrected', 'dy=' + Math.round(dy / scale));
        }
        ctx.drawImage(cI, 0, 0);
        ctx.drawImage(cN, 0, dy);
        c.toBlob(cb, 'image/png');
      });
    });
  }
  function attachSnapshot(wrap, done) {
    snapshot(wrap, function (blob) {
      var ok = false;
      try {
        if (blob && typeof DataTransfer !== 'undefined' && typeof File !== 'undefined') {
          var form = document.getElementById(wrap.getAttribute('data-form-id'));
          if (form) {
            var inp = form.querySelector('input[type="file"][name="properties[_flx_vista_previa]"]');
            if (!inp) {
              inp = document.createElement('input');
              inp.type = 'file';
              inp.name = 'properties[_flx_vista_previa]';
              inp.hidden = true;
              inp.tabIndex = -1;
              inp.setAttribute('aria-hidden', 'true');
              form.appendChild(inp);
            }
            var dt = new DataTransfer();
            dt.items.add(new File([blob], 'vista-previa.png', { type: 'image/png' }));
            inp.files = dt.files;
            ok = true;
          }
        }
      } catch (err) { ok = false; }
      if (done) done(ok);
    });
  }

  document.addEventListener('click', function (e) {
    var rst = e.target.closest('[data-flx-lp-reset]');
    if (rst) {
      var rWrap = wrapOf(rst);
      rWrap._flxScale = 1;
      rWrap._flxScaleWant = 1;
      rWrap._flxNamePos = null;     // vuelve a la colocación por defecto
      syncRange(rWrap);
      compose(rWrap);
      return;
    }
    var sizeBtn = e.target.closest('[data-flx-lp-size]');
    if (sizeBtn) {
      var sWrap = wrapOf(sizeBtn);
      var delta = parseInt(sizeBtn.getAttribute('data-flx-lp-size'), 10) * 0.1;
      sWrap._flxScale = clampScale(sWrap, (sWrap._flxScale || 1) + delta);
      sWrap._flxScaleWant = sWrap._flxScale;
      syncRange(sWrap);
      compose(sWrap);
      if (!sWrap._flxScaleTracked) { sWrap._flxScaleTracked = true; track(sWrap, 'flx_preview_resize', { via: 'boton' }); }
      return;
    }
    var confirmBtn = e.target.closest('[data-flx-lp-confirm]');
    if (confirmBtn) {
      var cWrap = wrapOf(confirmBtn);
      // Al confirmar viajan SIEMPRE posición y escala (se hayan tocado o
      // no) y se fija el estado guardado. Cada confirmación posterior
      // SOBRESCRIBE archivo y propiedades: el pedido lleva la última.
      var cNameEl = cWrap.querySelector('[data-flx-lp-name]');
      var cMode = cWrap.getAttribute('data-mode') || 'inicial';
      var posNow = (cMode !== 'nombre_svg' && cNameEl && cNameEl.textContent) ? currentNamePos(cWrap) : null;
      var scNow = Math.round((cWrap._flxScale || 1) * 100) / 100;
      if (posNow) cWrap._flxSaved = { x: posNow.x, y: posNow.y, s: scNow };
      cWrap._flxConfirmedThisOpen = true;
      track(cWrap, 'flx_preview_confirm', {
        name_moved: cWrap._flxNamePos ? 'si' : 'no',
        name_scaled: scNow !== 1 ? 'si' : 'no',
        seconds_open: secondsOpen(cWrap)
      });
      setPreviewState(cWrap, 'confirmada');
      attachSnapshot(cWrap, function () {
        if (posNow) {
          var nmEl = rootOf(cWrap).querySelector('[data-flx-lp-name]');
          var fix = nmEl && nmEl._flxFontFix ? nmEl._flxFontFix : 1;
          ensureHiddenProp(cWrap, 'x:' + posNow.x + '% y:' + posNow.y + '% escala:' + scNow
            + ' lienzo:' + (cWrap._flxCanvasSize || '?')
            + (Math.abs(fix - 1) > 0.05 ? ' ajuste:' + fix.toFixed(2) : '')
            + (cWrap._flxPhotoFix ? ' foto:' + cWrap._flxPhotoFix : ''));
        }
        closeAll();
        refreshMini(cWrap);
        var n = cWrap.querySelector('[data-flx-lp-notice]');
        if (n) { n.textContent = MSG.confirmed; n.classList.add('flx-lp__notice--ok'); n.hidden = false; }
      });
      return;
    }
    var openBtn = e.target.closest('[data-flx-lp-open]');
    if (openBtn) {
      e.preventDefault();
      openDialog(wrapOf(openBtn), openBtn);
      return;
    }
    if (e.target.closest('[data-flx-lp-close]') || e.target.closest('[data-flx-lp-backdrop]')) {
      closeAll();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && anyOpen()) closeAll();
  });

  // ── Mini-vista en vivo ──
  var __miniTimer = null;
  function refreshMini(wrap) {
    var mini = wrap.querySelector('[data-flx-lp-mini]');
    if (!mini) return;
    var sel = readSelection(wrap);
    var ready = sel.hasNameField ? !!sel.name : !!sel.initial;
    mini.classList.toggle('flx-lp__mini--empty', !ready);
    if (!ready) {
      var i0 = mini.querySelector('[data-flx-lp-initial]');
      var n0 = mini.querySelector('[data-flx-lp-name]');
      if (i0) { i0.textContent = ''; i0.innerHTML = ''; }
      if (n0) { n0.textContent = ''; n0.innerHTML = ''; }
      return;
    }
    compose(wrap, mini);
  }
  function refreshAllMini() {
    clearTimeout(__miniTimer);
    __miniTimer = setTimeout(function () {
      document.querySelectorAll('[data-flx-lp]').forEach(refreshMini);
    }, 120);
  }
  // El selector de tipografía asigna el valor por JS y NO dispara
  // input/change: se escucha su clic para repintar al instante.
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-flx-option]')) return;
    setTimeout(function () { refreshAllMini(); recomposeOpen(); }, 0);
  });
  // Control deslizante de tamaño
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-flx-lp-range]')) return;
    var w = wrapOf(e.target);
    w._flxScale = clampScale(w, (parseFloat(e.target.value) || 100) / 100);
    w._flxScaleWant = w._flxScale;
    compose(w);
    if (!w._flxScaleTracked) { w._flxScaleTracked = true; track(w, 'flx_preview_resize', { via: 'slider' }); }
  });
  document.addEventListener('input', refreshAllMini);
  document.addEventListener('change', refreshAllMini);
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input[data-variant-input]')) recomposeOpen();
  });
  window.addEventListener('resize', refreshAllMini);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refreshAllMini);
  // Las tipografías del nombre se cargan BAJO DEMANDA (al elegirlas):
  // la mini se compone con la fuente de sustitución y queda con el
  // tamaño equivocado. Cada vez que termina de cargar una fuente se
  // recompone todo (mini y editor) con las métricas reales.
  if (document.fonts && document.fonts.addEventListener) {
    document.fonts.addEventListener('loadingdone', function () {
      document.querySelectorAll('[data-flx-lp]').forEach(function (w) { w._flxRefitting = false; });
      refreshAllMini();
      recomposeOpen();
    });
  }
  refreshAllMini();
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-flx-lp-mini]');
    if (!m) return;
    var w = wrapOf(m);
    openDialog(w, m || w.querySelector('[data-flx-lp-open]'));
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-flx-lp-mini]')) {
      e.preventDefault();
      var w = wrapOf(e.target);
      openDialog(w, w.querySelector('[data-flx-lp-open]'));
    }
  });

  // Editar DESPUÉS de confirmar invalida la confirmación: la imagen
  // guardada ya no correspondería al texto del pedido. Se retira el PNG
  // y el estado vuelve a "abierta sin confirmar".
  function invalidateConfirm(wrap) {
    var form = document.getElementById(wrap.getAttribute('data-form-id'));
    if (!form) return;
    var st = form.querySelector('input[name="properties[_flx_preview_estado]"]');
    if (!st || st.value !== 'confirmada') return;
    setPreviewState(wrap, 'abierta sin confirmar');
    wrap._flxSaved = null;
    var f = form.querySelector('input[type="file"][name="properties[_flx_vista_previa]"]');
    if (f) { try { f.files = new DataTransfer().files; } catch (e) { f.value = ''; } }
    var pos = form.querySelector('input[name="properties[_flx_pos_nombre]"]');
    if (pos) pos.remove();
    var n = wrap.querySelector('[data-flx-lp-notice]');
    if (n) { n.hidden = true; n.classList.remove('flx-lp__notice--ok'); }
  }
  ['input', 'change'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var blk = e.target.closest && e.target.closest('[data-flx-p13n]');
      if (!blk) return;
      var fid = blk.getAttribute('data-form-id');
      var w = document.querySelector('[data-flx-lp][data-form-id="' + fid + '"]');
      if (w) invalidateConfirm(w);
    });
  });

  // Si el cliente cambia algo con el diálogo abierto, se recompone
  function recomposeOpen() {
    var dlg = anyOpen();
    if (!dlg) return;
    compose(wrapOf(dlg));
  }
  document.addEventListener('change', recomposeOpen);
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-flx-text]')) recomposeOpen();
  });
  window.addEventListener('resize', function () {
    clearTimeout(window.__flxLpRz);
    window.__flxLpRz = setTimeout(recomposeOpen, 150);
  });

  // Al escribir en los campos, se retira el aviso de "faltan datos"
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-flx-text]')) return;
    var p13n = e.target.closest('[data-flx-p13n]');
    if (!p13n) return;
    var formId = p13n.getAttribute('data-form-id');
    var wrap = document.querySelector('[data-flx-lp][data-form-id="' + formId + '"]');
    if (wrap) showNotice(wrap, null);
  });
})();
